import { pageLoadedInBrowser } from '../../../utils/commonUtils';
import React from 'react';

type AdRenderProps = {
  uuid: string;
  style?: any;
};
export const BrowserAdComponent = ({ uuid }) => {
  if (pageLoadedInBrowser()) {
    try {
      const AdComponent = require('ad-react-wrapper').default;
      return <AdComponent uuid={uuid} />;
    } catch (e) {
      console.log('Error in loading Ad:', e);
    }
  }
  return null;
};

export const validUUid = (uuid: string | []) => {
  switch (true) {
    case !uuid:
      return null;
    case typeof uuid == 'string':
      return uuid;
    case uuid.length > 0:
      return uuid;
    default:
      return null;
  }
};
export const AdsScrollComponent = React.memo(
  ({ style, uuid }: AdRenderProps) => {
    return (
      <div
        className={`${style.adComponent} whiteBackGroundColor`}
        style={{
          height: '136px',
          position: 'relative',
          zIndex: '1',
          padding: '15px 0px 15px 0px'
        }}
      >
        {validUUid(uuid) ? <BrowserAdComponent uuid={uuid} /> : null}
      </div>
    );
  }
);

export const SnackBarComponent = React.memo(({ uuid }: AdRenderProps) => {
  return validUUid(uuid) ? (
    <div style={{ position: 'relative', zIndex: '2' }}>
      <BrowserAdComponent uuid={uuid ? uuid : []} />
    </div>
  ) : null;
});
